<div id="project" class="page-layout emma simple carded fullwidth">
    <div class="header accent">
        @if (pageType == "edit") {
            <button mat-icon-button class="mr-0 mr-sm-16" [routerLink]="'/admin/projects'">
                <mat-icon>arrow_back</mat-icon>
            </button>
        }

        @if (pageType == "new") {
            <h1>{{ "PROJECTS.Project" | translate }} - {{ "PROJECTS.Create" | translate }}</h1>
        }
        @if (pageType == "edit") {
            <h1>{{ "PROJECTS.Project" | translate }} - {{ project.name }}</h1>
        }
    </div>

    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT CARD -->
        <div class="content-card">
            <mat-tab-group [backgroundColor]="'header'">
                <!-- Project Info Tab -->
                <mat-tab label="{{ 'PROJECTS.BasicInfo' | translate }}">
                    <div class="content">
                        <form name="projectForm" [formGroup]="projectForm" class="company">
                            <div class="section">
                                <mat-form-field appearance="outline">
                                    <mat-label>{{ "PROJECTS.ProjectName" | translate }}</mat-label>
                                    <input
                                        matInput
                                        name="name"
                                        formControlName="name"
                                        placeholder="{{ 'PROJECTS.ProjectName' | translate }}"
                                        required
                                    />
                                </mat-form-field>
                                <div class="section__row">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "PROJECTS.Timezone" | translate }}</mat-label>
                                        <mat-select formControlName="timezone" placeholder="{{ 'PROJECTS.Timezone' | translate }}" required>
                                            @for (timezone of timeZones; track timezone) {
                                                <mat-option [value]="timezone">
                                                    {{ timezone }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "PROJECTS.Dateformat" | translate }}</mat-label>
                                        <mat-select
                                            formControlName="dateformat"
                                            placeholder="{{ 'PROJECTS.Dateformat' | translate }}"
                                            required
                                        >
                                            @for (dateformat of dateformats; track dateformat) {
                                                <mat-option [value]="dateformat">
                                                    {{ dateformat }}
                                                </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="section__example">
                                    {{ "PROJECTS.Example" | translate }}:
                                    {{ date | date: project.dateformat : timezone }}
                                </div>
                            </div>
                            <!-- Form actions -->
                            <div class="form-action">
                                @if (pageType == "new") {
                                    <button
                                        mat-raised-button
                                        class="button-save"
                                        color="primary"
                                        [disabled]="projectForm.invalid"
                                        (click)="add()"
                                    >
                                        {{ "PROJECTS.ADD" | translate }}
                                    </button>
                                }
                                @if (pageType == "new") {
                                    <button mat-raised-button (click)="cancel()">
                                        {{ "PROJECTS.CANCEL" | translate }}
                                    </button>
                                }
                            </div>
                        </form>
                    </div>
                </mat-tab>
                @if (pageType === "edit") {
                    <mat-tab label="{{ 'PROJECTS.Devices' | translate }}">
                        <div class="project-device-content">
                            <app-project-devices [project]="project"></app-project-devices>
                        </div>
                    </mat-tab>
                }
                @if (pageType === "edit") {
                    <mat-tab label="{{ 'PROJECTS.Periods' | translate }}">
                        <div class="app-project-periods">
                            <app-project-periods [project]="project"></app-project-periods>
                        </div>
                    </mat-tab>
                }
                @if (pageType === "edit") {
                    <mat-tab label="{{ 'PROJECTS.Alarms' | translate }}">
                        <div class="app-project-alarms">
                            <app-project-alarm [project]="project"></app-project-alarm>
                        </div>
                    </mat-tab>
                }
                <mat-tab label="{{ 'PROJECTS.NotificationChannels' | translate }}">
                    <div class="project-notification-channel-content">
                        <form [formGroup]="projectForm">
                            <div class="section notification-channels-section">
                                <div class="notification-channel-table-container">
                                    <mat-table class="notification-channel-table" [dataSource]="notificationChannelRows" fusePerfectScrollbar>
                                        <ng-container matColumnDef="name">
                                            <mat-header-cell *matHeaderCellDef>
                                                {{ "PROJECTS.NotificationChannelName" | translate }}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let channel">
                                                <p class="text-truncate" [matTooltip]="channel.get('name')?.value">
                                                    {{ channel.get("name")?.value }}
                                                </p>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="type">
                                            <mat-header-cell *matHeaderCellDef>
                                                {{ "PROJECTS.NotificationChannelTypeLabel" | translate }}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let channel">
                                                <p class="text-truncate">
                                                    {{ getChannelTypeLabel(channel.get("type")?.value) }}
                                                </p>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="enabled">
                                            <mat-header-cell *matHeaderCellDef>
                                                {{ "PROJECTS.NotificationChannelEnabled" | translate }}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let channel">
                                                <mat-slide-toggle
                                                    [checked]="channel.get('enabled')?.value !== false"
                                                    (click)="$event.stopPropagation()"
                                                    (change)="setNotificationChannelEnabled(channel, $event.checked)"
                                                >
                                                </mat-slide-toggle>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="buttons">
                                            <mat-header-cell class="cell-check" *matHeaderCellDef></mat-header-cell>
                                            <mat-cell class="cell-check" *matCellDef="let channel">
                                                <div class="notification-channel-actions" fxFlex="row" fxLayoutAlign="end center">
                                                    <button
                                                        mat-icon-button
                                                        type="button"
                                                        color="primary"
                                                        [attr.aria-label]="'PROJECTS.NotificationChannelSendTest' | translate"
                                                        [matTooltip]="'PROJECTS.NotificationChannelSendTest' | translate"
                                                        [disabled]="!channel.get('id')?.value || isTestingNotificationChannel(channel)"
                                                        (click)="sendNotificationChannelTest(channel, $event)"
                                                    >
                                                        <mat-icon>
                                                            {{ isTestingNotificationChannel(channel) ? "hourglass_top" : "send" }}
                                                        </mat-icon>
                                                    </button>
                                                    <button
                                                        mat-icon-button
                                                        type="button"
                                                        color="warn"
                                                        [attr.aria-label]="'PROJECTS.NotificationChannelRemove' | translate"
                                                        [matTooltip]="'PROJECTS.NotificationChannelRemove' | translate"
                                                        (click)="removeNotificationChannel(getNotificationChannelIndex(channel), $event)"
                                                    >
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                            </mat-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="notificationChannelDisplayedColumns; sticky: true"></mat-header-row>
                                        <mat-row
                                            *matRowDef="let channel; columns: notificationChannelDisplayedColumns"
                                            class="notification-channel-row row-pointer"
                                            matRipple
                                            (click)="editNotificationChannel(getNotificationChannelIndex(channel))"
                                        ></mat-row>
                                    </mat-table>
                                </div>

                                <div class="add-button">
                                    <button
                                        mat-fab
                                        type="button"
                                        aria-label="add channel"
                                        (click)="addNotificationChannel()"
                                        [@animate]="{ value: '*', params: { delay: '300ms', scale: '.2' } }"
                                    >
                                        <mat-icon>add_circle_outline</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
